import { Waypoint } from "react-waypoint";

import Loader          from "_components/atoms/loader";
import CreatorCardList from "_components/molecules/creatorCardList";

const component = ( {
	data,
	fetchMore,
	isDepleted,
	isLoading
} ) => {

	return (
		<div>
			<CreatorCardList list = { data } />

			{isLoading && <Loader size = { "xl" } /> }

			{ !isDepleted && !isLoading && (
				<Waypoint
					onEnter = { () => {
						fetchMore ( );
					} }
				/>
			)}
		</div>
	);
};

export default component;